import { combineReducers } from '@reduxjs/toolkit';

import calendarReducer from './calendar';
import * as usersReducers from './users';

export const weeklyPlanner = {
  ...usersReducers,
  calendar: calendarReducer,
};

export default combineReducers(weeklyPlanner);
